<template>
  <div>
    <Modal title="提现明细" width="1000" v-model="visible" :mask-closable="false" :footer-hide="true" class="my-modal min">
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData"> </Table>
        <Button type="primary" @click="download">结算函及明细下载</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal" />
  </div>
</template>
  
<script>
import confirmModal from '@/components/commons/confirmModal';
import { pageTool, common } from '@/api/mixins';
export default {
  props: [],
  mixins: [pageTool, common],
  components: { confirmModal },
  data() {
    return {
      tabs: [
        {
          txt: '全部',
          val: ''
        }
      ],
      searchParams: {},
      columns: [
        {
          title: '结算主体',
          key: 'subCompanyName',
          align: 'center',
          minWidth: 210
        },
        {
          title: '结算期数',
          key: 'settlementIndex',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            const text = params.row.settlementIndex;
            return <span>{text == 1 ? '首期' : '第' + text + '期'}</span>;
          }
        },
        {
          title: '总保费（元）',
          key: 'totalPrice',
          align: 'center',
          minWidth: 120
        },
        {
          title: '保单数',
          key: 'totalNumber',
          align: 'center',
          minWidth: 100
        },
        {
          title: '应结费用（元）',
          key: 'totalCommission',
          align: 'center',
          minWidth: 120
        },
        {
          title: '实际收入（元）',
          key: 'settleCommission',
          align: 'center',
          minWidth: 120
        }
      ],
      tableData: [],
      operation: '',
      visible: false,
      loading: false
    };
  },
  mounted() {},
  methods: {
    // 打开弹窗
    open(operation, row) {
      this.operation = operation;
      let data = JSON.parse(JSON.stringify(row));
      this.tabs = [
        {
          txt: '全部',
          val: ''
        }
      ];
      this.visible = true;
      this.searchParams = { withdrawLogId: data.id };
      this.initListAjax('/buz/settlementTotal/queryMergeSettled');
    },
    // 下载资料
    download() {
      this.$units.downloadFile('/buz/settlementDetail/settleConfirmDownload', { withdrawLogId: this.searchParams.withdrawLogId }, 'get', '', '', false);
      this.openConfirmModal('下载成功');
    },
    // 打开确认窗
    openConfirmModal(title) {
      if (this.operation == 'add') {
        window.setTimeout(() => {
          this.$refs.confirmModal
            .open({
              title: title,
              okText: '立即前往',
              content: '可前往提现记录查看待上传发票的提现记录，上传发票等资料。'
            })
            .then(() => {
              this.visible = false;
              this.$nextTick(() => {
                sessionStorage.query = JSON.stringify({ tabId: '1' });
                this.$router.push({
                  path: '/settlementManage/financialRecord'
                });
              });
            });
        }, 2000);
      } else {
        this.visible = false;
      }
    },
    setListParams(params) {
      if (!params.commissionPeriod) {
        delete params.commissionPeriod;
      }
    }
  }
};
</script>
  
<style lang="scss" scoped>
.table-box {
  padding-top: 20px;
}
</style>
  